module.exports = __webpack_public_path__ + "static/the-ten-commandments-for-business-failure-45d565b1c6ec90514e7d66a27d5b6a1b.jpg";